// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1X982","left":"StickyBox_left__1K8Bh","right":"StickyBox_right__388B6"};